import api from '../../utils/api';

export type VendorProfileType =
  | 'clinic'
  | 'ambulance'
  | 'hospital'
  | 'medical_store'
  | 'blood_bank'
  | 'diagnostic_center'
  | 'delivery_partner'
  | 'product_partner';

export interface VendorProfileUpdateLogRow {
  id: string;
  vendorId: string;
  vendorRole: number | null;
  vendorRoleLabel?: string;
  vendorDisplayName: string | null;
  /** Present for clinic/doctor rows when enriched by API */
  doctorName?: string | null;
  clinicName?: string | null;
  vendorGeneratedId: string | null;
  profileType: VendorProfileType;
  profileTypeLabel?: string;
  sourceEndpoint: string | null;
  httpMethod: string | null;
  changedFields: string[];
  changedFieldKeys: string[] | null;
  profileBefore: Record<string, unknown> | null;
  profileAfter: Record<string, unknown>;
  updatePayload: Record<string, unknown> | null;
  metadata: Record<string, unknown> | null;
  updatedByType: 'VENDOR' | 'MASTER_ADMIN' | 'SYSTEM';
  updatedById: string | null;
  createdAt: string;
  Vendor?: {
    vendorId: string;
    email?: string;
    phoneNumber?: string;
    generatedId?: string;
    vendorRole?: number;
    status?: string;
  };
}

export interface ListVendorProfileUpdatesParams {
  page?: number;
  limit?: number;
  vendorId?: string;
  profileType?: VendorProfileType;
  vendorRole?: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const PROFILE_TYPE_OPTIONS: { value: '' | VendorProfileType; label: string }[] = [
  { value: '', label: 'All vendor types' },
  { value: 'clinic', label: 'Doctor / Clinic' },
  { value: 'ambulance', label: 'Ambulance' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'medical_store', label: 'Medical Store' },
  { value: 'blood_bank', label: 'Blood Bank' },
  { value: 'diagnostic_center', label: 'Diagnostic Center' },
  { value: 'delivery_partner', label: 'Delivery Partner' },
  { value: 'product_partner', label: 'Product Partner' },
];

export async function fetchVendorProfileUpdates(
  params?: ListVendorProfileUpdatesParams
): Promise<{
  success: boolean;
  data: VendorProfileUpdateLogRow[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}> {
  const response = await api.get('/master-admin/vendor-profile-updates', { params });
  return response.data;
}

export async function fetchVendorProfileUpdateById(
  id: string
): Promise<{ success: boolean; data: VendorProfileUpdateLogRow }> {
  const response = await api.get(
    `/master-admin/vendor-profile-updates/${encodeURIComponent(id)}`
  );
  return response.data;
}
